import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteSessionQuery } from '@app/store/session/session.query';
import { InsuranceType } from '@models/InsuranceType';
import { Quote } from '@models/Quote';
import { Observable, map } from 'rxjs';

@Component({
	selector: 'qe-accident-only-coverage-modal',
	templateUrl: './coverages-modal.component.html',
	styleUrls: ['./coverages-modal.component.scss'],
})
export class CoveragesModalComponent {

	public readonly quoteDetails$: Observable<Quote>;
	public readonly isModelLawState$: Observable<boolean>;
	public readonly accidentIllness: InsuranceType = InsuranceType.AccidentIllness;
	public readonly accidentOnly: InsuranceType = InsuranceType.AccidentOnly;
	private readonly MODEL_LAW_STATE_IDENTIFIER: number = 6;

	constructor(
		private readonly dialogRef: MatDialogRef<CoveragesModalComponent>,
		private readonly session: QuoteSessionQuery,
		@Inject(MAT_DIALOG_DATA) public data: InsuranceType,
	) {
		this.quoteDetails$ = this.session.quoteDetailsState$();
		this.isModelLawState$ = this.quoteDetails$.pipe(
			map((quote: Quote) => Number(quote.productVersion) >= this.MODEL_LAW_STATE_IDENTIFIER),
		);
	}
}
